import { render, staticRenderFns } from "./historicoDeRegistros.vue?vue&type=template&id=5a0b3f81&scoped=true"
import script from "./historicoDeRegistros.vue?vue&type=script&lang=js"
export * from "./historicoDeRegistros.vue?vue&type=script&lang=js"
import style0 from "./historicoDeRegistros.vue?vue&type=style&index=0&id=5a0b3f81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b3f81",
  null
  
)

export default component.exports